export function encodeUrlParam(payloadObject) {
  try {
    return !payloadObject ? null : encodeURI(Buffer.from(JSON.stringify(payloadObject)).toString('base64'));
  } catch (e) {
    return null;
  }
}

export function decodeUrlParam(urlParam) {
  try {
    return !urlParam ? null : JSON.parse(Buffer.from(decodeURI(urlParam), 'base64').toString());
  } catch (e) {
    return null;
  }
}
